import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

interface StyledSeatProps {
  isUserBooked?: boolean
  isBankHoliday?: boolean
  alt?: string
}

export const KeyWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`

export const Seat = styled.div`
  width: 27px;
  aspect-ratio: 1 / 1;
  border-radius: 10px 10px 0px 0px;
  background: ${props => props.theme.colours.white};
  border: 1px solid black;
`
export const BookedSeat = styled(Seat)`
  background: ${props => props.theme.colours.red};
  border-style: none;
`
export const KeyText = styled.p`
  ${DefaultFontStyle};
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  color: #747474;
  margin: 0px 22px -3px 7px;
`

export const SeatPickerGrid = styled.div`
  margin: 20px auto;
  display: grid;
  grid-template-columns: repeat(4, minmax(34px, 67px));
  row-gap: 20px;
  column-gap: 5%;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    grid-template-columns: repeat(6, minmax(34px, 67px));
    margin: 36px 0px 0px;
  }
`

export const HoverText = styled.span`
  visibility: hidden;
  background-color: ${props => props.theme.colours.white};
  color: ${props => props.theme.colours.black};
  box-shadow: 2px 2px 0px ${props => props.theme.colours.black}70;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
`

export const AvailableSeat = styled(Seat)<StyledSeatProps>`
  ${DefaultFontStyle};
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: ${props => props.theme.colours.white};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:hover {
    ${HoverText} {
      visibility: visible;
      top: 50px;
    }
  }
`

export const OccupiedSeat = styled(AvailableSeat)`
  background: ${props => props.theme.colours.red};
  border-style: none;
  user-select: none;
`

export const PlusIcon = styled.div<StyledSeatProps>`
  width: 38px;
  height: 38px;
  background: ${props =>
    props.isUserBooked || props.isBankHoliday
      ? `${props.theme.colours.black}20`
      : props.theme.colours.paleGreen};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => !props.isUserBooked && 'pointer'};
`

export const HorizontalLine = styled.div`
  position: relative;
  top: 0px;
  left: 12px;
  height: 24px;
  width: 1px;
  background: ${props => props.theme.colours.black};
`

export const VerticalLine = styled(HorizontalLine)`
  left: 0px;
  height: 1px;
  width: 24px;
`
export const ErrorText = styled.p`
  white-space: pre-line;
`
